/**
 * Import required libraries
 */
import React from "react";
import { connect } from "react-redux";
import labels from "./labels";

/**
 * Import required elements
 */
// Material-ui components
import { Typography } from "@material-ui/core";
import styles from "./styles";

/**
 * Group Render JSX
 */
const GroupRender = props => { 
  const {
    logo,
    groupName,
    notFound, // state
    lang,
    style
  } = props;

  // CSS classnames
  const classes = styles(props);

  if (logo) {
    return (
      <img className={classes.GroupLogo}
        src={logo} alt=""
        style={style || null}
      />
    );
  } else if (notFound)
    return (
      <div className={classes.noLogoRoot}>
        <Typography
          noWrap
          className={classes.noLogoTypo}
          variant={props.variant || "h5"}
          align="center"
        >
          {groupName ? groupName : labels["yourlogo"][lang]}
        </Typography>
      </div>
    );
  return null;
};

/**
 * Export component
 */
// map redux state to props
export default connect(state => ({
  lang: state.locale.lang
}))(GroupRender);
